<template>
    <div class="choose_date_range_wrapper" v-click-outside="closeCalendarForm">
      <span class="choose_date_range" @click="toggleCalendarForm">
        <template v-if="compareDates">
          <div style="display: grid; grid-template-columns: auto 30px;">
            <div>
              {{dateStart | formatFullDate}} - {{dateEnd | formatFullDate}} <br/>
              <div class="small">vs {{dateStartB | formatFullDate}} - {{dateEndB | formatFullDate}}</div>
            </div>
            <i class="arrow-drop-down"></i>
          </div>
        </template>
        <template v-else>
          <span v-if="showDateRange">{{dateStart | formatFullDate}} - {{dateEnd | formatFullDate}}</span>
          <i class="arrow-drop-down"></i>
        </template>
      </span>
        <div class="calendar-wrapper" v-show="showCalendar">
            <div class="calendar-options-wrapper">
                <template v-if="this.$md.mobile() !== null">
                    <div class="mobile-close-wrapper" v-bind:style="{'top': scrollOffsetY + 'px'}">
                        <i class="close" @click="cancelChanges(actionEvent)"></i>
                        <span>Date Range</span>
                        <span class="save" @click="applyChanges(actionEvent)">Save</span>
                    </div>
                </template>
                <div class="date_range_option" @click="selectDateRange(null)" v-bind:class="{active: selectedOption == null}">Custom</div>
                <div class="delimiter"></div>
                <div class="date_range_option" @click="selectDateRange('today')" v-bind:class="{active: selectedOption == 'today'}">Today</div>
                <div class="date_range_option" @click="selectDateRange('yesterday')" v-bind:class="{active: selectedOption == 'yesterday'}">Yesterday</div>
                <div class="date_range_option" @click="selectDateRange('week')" v-bind:class="{active: selectedOption == 'week'}">This week</div>
                <div class="date_range_option" @click="selectDateRange('last week')" v-bind:class="{active: selectedOption == 'last week'}">Last week</div>
                <div class="date_range_option" @click="selectDateRange('month')" v-bind:class="{active: selectedOption == 'month'}">This month</div>
                <div class="date_range_option" @click="selectDateRange('last month')" v-bind:class="{active: selectedOption == 'last month'}">Last month</div>
                <div class="delimiter"></div>
                <div class="date_range_option" @click="selectDateRange('days up to date')" v-bind:class="{active: selectedOption == 'days up to date'}">
                    <input v-model="up_to_today" class="date-range-option-input">
                    <span>days up to today</span>
                </div>
                <div class="date_range_option" @click="selectDateRange('days up to yesterday')" v-bind:class="{active: selectedOption == 'days up to yesterday'}">
                    <input v-model="up_to_yesterday" class="date-range-option-input">
                    <span>days up to yesterday</span>
                </div>
                <div class="date_range_option">
                    <CCSwitchToggle :action="excludeYesterdayAction" textBefore="Exclude yesterday" style="display: flex;justify-content: space-between;"></CCSwitchToggle>
                </div>
                <div class="date_range_option">
                    <CCSwitchToggle :action="excludeCustomDateAction" textBefore="Exclude custom date" :checked="excludedDates.length > 0" style="display: flex;justify-content: space-between;"></CCSwitchToggle>
                </div>
                <div class="delimiter"></div>
                <div class="date_range_option">
                    <CCSwitchToggle :action="compareDatesAction" textBefore="Compare" style="display: flex;justify-content: space-between;" :checked="compareDates === true"></CCSwitchToggle>
                    <div v-if="compareDates" class="compare-dates-options">
                        <div class="date_range_option" @click="selectDateRangeCompare('previous period')" v-bind:class="{activeCompare: selectedOptionCompare == 'previous period'}">Previous period</div>
                        <div class="date_range_option" @click="selectDateRangeCompare('previous year')" v-bind:class="{activeCompare: selectedOptionCompare == 'previous year'}">Previous year</div>
                        <div class="date_range_option" @click="selectDateRangeCompare(null)" v-bind:class="{activeCompare: selectedOptionCompare == null}">Custom</div>
                    </div>
                </div>
            </div>
            <div class="calendar-main">
                <div class="calendar-header">
                    <div class="selectedRange">
                        <template v-if="compareDates">
                            <div>
                                <span class="start_date" @click="selectStartDate" v-bind:class="{active: startDateIsActive}">{{selectedStartDate | formatFullDate}}</span>
                                <span style="font-size: 18px;color: #c7c7c7; vertical-align: sub;">&#8212;</span>
                                <span class="end_date" @click="selectEndDate" v-bind:class="{active: endDateIsActive}">{{selectedEndDate | formatFullDate}}</span>
                            </div>
                            <div class="vs-wrapper">
                                <span>VS</span>
                            </div>
                            <div>
                                <span class="start_date" @click="selectStartDateB" v-bind:class="{activeB: startDateBIsActive}">{{selectedStartDateB | formatFullDate}}</span>
                                <span style="font-size: 18px;color: #c7c7c7; vertical-align: sub;">&#8212;</span>
                                <span class="end_date" @click="selectEndDateB" v-bind:class="{activeB: endDateBIsActive}">{{selectedEndDateB | formatFullDate}}</span>
                            </div>
                        </template>
                        <template v-else>
                            <span class="start_date" @click="selectStartDate" v-bind:class="{active: startDateIsActive}">{{selectedStartDate | formatFullDate}}</span>
                            <span style="font-size: 18px;color: #c7c7c7; vertical-align: sub;">&#8212;</span>
                            <span class="end_date" @click="selectEndDate" v-bind:class="{active: endDateIsActive}">{{selectedEndDate | formatFullDate}}</span>
                        </template>
                    </div>
                    <div class="calendar-month-picker">
                        <div class="prevMonth" @click="showPrevMonth">
                            <i class="arrow-left"></i>
                        </div>
                        <span style="text-align: center;">
                <span @click="showMonthesList" style="cursor: pointer;">
                  {{setMonthes.selectedMonth | formatMonth}}, {{setMonthes.selectedMonth | formatYear}}
                  <template v-if="isShowMonthesList">
                    <i class="arrow-top"></i>
                  </template>
                  <template v-else>
                    <i class="arrow-bottom"></i>
                  </template>
                </span>
              </span>
                        <div class="nextMonth" @click="showNextMonth">
                            <i class="arrow-right"></i>
                        </div>
                    </div>
                    <div class="weekDays">
              <span v-for="weekDay in currentWeekDays">
                {{weekDay}}
              </span>
                    </div>
                    <div class="delimiter"></div>
                    <div class="monthes-list-wrapper" v-show="isShowMonthesList">
                        <div class="monthes-list-header">{{twoYearsAgo | formatYear}}</div>
                        <div class="monthes-list">
                            <template v-for="month in monthesList">
                                <div @click="useMonth(month, twoYearsAgo)">{{month}}</div>
                            </template>
                        </div>
                        <div class="monthes-list-header">{{previousYear | formatYear}}</div>
                        <div class="monthes-list">
                            <template v-for="month in monthesList">
                                <div @click="useMonth(month, previousYear)">{{month}}</div>
                            </template>
                        </div>
                        <div class="monthes-list-header">{{currentYear | formatYear}}</div>
                        <div class="monthes-list">
                            <template v-for="month in monthesList">
                                <div @click="useMonth(month, currentYear)">{{month}}</div>
                            </template>
                        </div>
                        <div class="monthes-list-header">{{nextYear | formatYear}}</div>
                        <div class="monthes-list">
                            <template v-for="month in monthesList">
                                <div @click="useMonth(month, nextYear)">{{month}}</div>
                            </template>
                        </div>
                    </div>
                    <div style="text-align: center;margin-bottom: 15px;">
                        {{setMonthes.selectedMonth| formatMonth}}, {{setMonthes.selectedMonth | formatYear}}
                    </div>
                    <div class="monthDays">
                        <div v-for="offset in offsetWeekDaysInCurrentMonth">
                            <span class="day-offset"></span>
                        </div>
                        <template v-for="(days, week) in daysInSelectedMonth">
                            <div v-for="day in days" @click="clickOnDate(day)" v-bind:class="{highlighted: isHighLighted(day),
                                                                                             highlightedB: isHighLightedB(day),
                                                                                             active: clickableDay == day,
                                                                                             selected: isSelected(day),
                                                                                             selectedB: isSelectedB(day),
                                                                                             disabled: isDisabled(day),
                                                                                             startDate: isStartDate(day),
                                                                                             endDate: isEndDate(day),
                                                                                             excludedDay: isExcluded(day),
                                                                                             startDateB: isStartDateB(day),
                                                                                             endDateB: isEndDateB(day),
                                                                                             excludedDayB: isExcludedB(day)}">

                                <span v-bind:class="{active: clickableDay == day, selected: isSelected(day), selectedB: isSelectedB(day)}">{{day | formatShortDate}}</span>
                            </div>
                        </template>
                    </div>
                    <div style="text-align: center;margin-bottom: 15px;">
                        {{setMonthes.nextMonth | formatMonth}}, {{setMonthes.nextMonth | formatYear}}
                    </div>
                    <div class="nextMonthDays">
                        <div v-for="offset in offsetAfterSelectedMonth">
                            <span class="day-offset"></span>
                        </div>
                        <template v-for="(days, week) in daysInNextMonth">
                            <div v-for="day in days" @click="clickOnDate(day)" v-bind:class="{highlighted: isHighLighted(day),
                                                                                             highlightedB: isHighLightedB(day),
                                                                                             active: clickableDay == day ,
                                                                                             selected: isSelected(day),
                                                                                             selectedB: isSelectedB(day),
                                                                                             disabled: isDisabled(day),
                                                                                             startDate: isStartDate(day),
                                                                                             endDate: isEndDate(day),
                                                                                             excludedDay: isExcluded(day),
                                                                                             startDateB: isStartDateB(day),
                                                                                             endDateB: isEndDateB(day),
                                                                                             excludedDayB: isExcludedB(day)}">

                                <span v-bind:class="{active: clickableDay == day, selected: isSelected(day), selectedB: isSelectedB(day)}">{{day | formatShortDate}}</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="control-buttons-wrapper">
                <div class="control-wrapper">
                    <div style="margin-right: 15px;margin-bottom: 10px;">
                        <button class="cancel-action" @click="cancelChanges(actionEvent)">Cancel</button>
                    </div>
                    <div>
                        <button class="apply-action" @click="applyChanges(actionEvent)">Apply</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment';
    import lodash from 'lodash';
    import 'keen-ui/src/bootstrap';
    import CCSwitchToggle from '@/components/common/CCSwitchToggle';
    import {dateFormatDefault} from "@/helpers/format";

    export default {
        name: "cc-calendar",
        components: {
            CCSwitchToggle
        },
        props: {
            actionEvent: {
                type: Function,
                required: true
            },
            namespace: {
                type: String,
                required: true
            },
            dates: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                showCalendar: false,
                excludeYesterday: false,
                excludeCustomDate: null,
                compareDates: null,
                startDateIsActive: true,
                endDateIsActive: false,
                startDateBIsActive: false,
                endDateBIsActive: false,
                dateStart: null,
                dateEnd: null,
                dateStartB: null,
                dateEndB: null,
                selected: null,
                clickableDays: true,
                clickableDay: null,
                showDateRange: true,
                monthes: {
                    selectedMonth: moment(),
                    prevMonth: moment().clone().subtract(1, 'month'),
                    nextMonth: moment().clone().add(1, 'month')
                },
                excludedDates: [],
                excludedDatesB: [],
                isShowMonthesList: false,
                currentYear: moment(),
                selectedOption: null,
                selectedOptionCompare: null,
                up_to_today: 30,
                up_to_yesterday: 30
            };
        },
        mounted: function(){
            this.setDates();

            if (this.excludedDates.length)
            {
                this.excludeCustomDate = true;
            }

            let compareDatesStatus = this.$store.getters[this.namespace + '/isDatesComparisonEnabled'];

            if (compareDatesStatus !== null)
            {
                this.compareDates = compareDatesStatus;
            }

            this.actionEvent(this.dateStart, this.dateEnd, this.dateStartB, this.dateEndB, this.excludedDates, this.excludedDatesB);
        },
        filters: {
            formatFullDate: function(date) {
                if (date)
                {
                    return date.format(dateFormatDefault());
                }
            },
            formatShortDate: function(date) {
                if (date)
                {
                    return date.format('D');
                }
            },
            formatMonth: function(date) {
                return date.format('MMM');
            },
            formatYear: function(date) {
                return date.format('YYYY');
            }
        },
        computed: {
            scrollOffsetY: function(){
                return this.$store.getters.getScrollOffsetY;
            },
            monthesList: function(){
                return moment.monthsShort();
            },
            setMonthes: {
                get: function(){
                    return this.monthes;
                },
                set: function(value){
                    this.monthes = value;
                }
            },
            selectedStartDate: function(){
                return this.dateStart;
            },
            selectedEndDate: function(){
                return this.dateEnd;
            },
            selectedStartDateB: function(){
                return this.dateStartB;
            },
            selectedEndDateB: function(){
                return this.dateEndB;
            },
            selectedDate: function(){
                return moment();
            },
            getPreviousMonth: function(){
                return this.prevMonth;
            },
            currentWeekDays: function(){
                return moment.weekdaysShort();
            },
            offsetWeekDaysInCurrentMonth: function(){
                let offset = this.monthes.selectedMonth.clone().startOf('month').day();

                return offset;
            },
            daysInSelectedMonth: function(){

                let startDateInMonth = this.monthes.selectedMonth.clone().startOf('month');
                let endDateInMonth = this.monthes.selectedMonth.clone().endOf('month');

                let dates = [];
                var index = startDateInMonth.clone().add(-1, 'day');
                while(index.isBefore(endDateInMonth, 'day'))
                {
                    dates.push(new Array(7).fill(0).map(() => index.add(1, 'day').clone()));
                }

                return dates.map(week => week.filter(date => date.isSameOrBefore(endDateInMonth, 'day')));
            },
            offsetAfterSelectedMonth: function(){
                let offset = this.monthes.nextMonth.clone().startOf('month').day();

                return offset;
            },
            daysInNextMonth: function(){
                let startDateInMonth = this.monthes.nextMonth.clone().startOf('month');
                let endDateInMonth = this.monthes.nextMonth.clone().endOf('month');

                let dates = [];
                var index = startDateInMonth.add(-1, 'day');
                while(index.isBefore(endDateInMonth, 'day'))
                {
                    dates.push(new Array(7).fill(0).map(() => index.add(1, 'day').clone()));
                }

                return dates.map(week => week.filter(date => date.isSameOrBefore(endDateInMonth, 'day')));
            },
            previousYear: function(){
                return this.currentYear.clone().add(-1, 'year');
            },
            twoYearsAgo: function() {
                return this.currentYear.clone().add(-2, 'year');
            },
            nextYear: function(){
                return this.currentYear.clone().add(1, 'year');
            }
        },
        watch: {
            compareDates: function(value)
            {
                if (value)
                {
                    this.dateStartB = moment().add(-1, 'days');
                    this.dateEndB = moment().add(-1, 'days');

                    this.selectStartDateB();
                }
            },
            excludeCustomDate: function(value)
            {
                if (value == false)
                {
                    this.excludedDates = [];
                }
            },
            excludeYesterday: function(value)
            {
                let yesterday = moment().add(-1, 'day').clone();
                let index = this.excludedDates.findIndex(item => item.isSame(yesterday, 'day'));

                if (value)
                {
                    if (index == -1)
                    {
                        this.excludedDates.push(yesterday);
                    }
                }
                else
                {
                    if (index !== -1)
                    {
                        this.excludedDates.splice(index, 1);
                    }
                }
            },
            up_to_today: function(value)
            {
                this.dateStart = moment().add( - value, 'day').clone();
                this.dateEnd = moment().clone();
            },
            up_to_yesterday: function(value)
            {
                this.dateStart = moment().add( - value, 'day').clone();
                this.dateEnd = moment().add(-1, 'day').clone();
            }
        },
        methods: {
            _initializeDates: function(dates){
                this.dateStart = moment(dates.startDate);
                this.dateEnd = moment(dates.endDate);

                if (dates.startDateB && dates.endDateB)
                {
                    this.dateStartB = moment(dates.startDateB);
                    this.dateEndB = moment(dates.endDateB);

                    if (dates.excludedDatesB)
                    {
                        if(Array.isArray(dates.excludedDatesB))
                        {
                            this.excludedDatesB = dates.excludedDatesB.map(date => moment(date));
                        }
                        else
                        {
                            this.excludedDatesB = [moment(dates.excludedDatesB)];
                        }
                    }
                }

                if (dates.excludedDates)
                {
                    if(Array.isArray(dates.excludedDates))
                    {
                        this.excludedDates = dates.excludedDates.map(date => moment(date));
                    }
                    else
                    {
                        this.excludedDates = [dates(dates.excludedDates)];
                    }
                }
            },
            setDates: function(){
                let foundDates = false;
                let filters = false;
                if( this.$store.getters.hasOwnProperty(this.namespace + '/getFilters') ) {
                    let filtersList = this.$store.getters[this.namespace + '/getFilters'];
                    filters = filtersList.filters;
                    let vuexDates = filters.dateRange;

                    if (filtersList.filters && filtersList.filters.dateRange)
                    {
                        this._initializeDates(vuexDates);
                        foundDates = true;
                    }
                }

                if( ! foundDates ) {

                    if (this.dates && this.dates.startDate && this.dates.endDate)
                    {
                        this._initializeDates(this.dates);
                    }
                    else
                    {
                        this._initializeDates({
                            startDate: moment().add(-1, 'day').clone(),
                            endDate: moment().add(-1, 'day').clone()
                        });
                    }
                }

                if (filters && filters.datesComparison)
                {
                    this.$store.dispatch(this.namespace + '/setDateComparisonStatus', filters.datesComparison == 'true');
                }
            },
            toggleCalendarForm: function(){
                this.showCalendar = !this.showCalendar;
            },
            closeCalendarForm: function(){
                this.showCalendar = false;
            },
            showPrevMonth: function(){
                this.setMonthes = {
                    selectedMonth: this.monthes.selectedMonth.add(-1, 'month'),
                    prevMonth: this.monthes.selectedMonth.clone().add(-2, 'month'),
                    nextMonth: this.monthes.selectedMonth.clone().add(1, 'month')
                };
            },
            showNextMonth: function(){
                this.setMonthes = {
                    selectedMonth: this.monthes.selectedMonth.add(1, 'month'),
                    prevMonth: this.monthes.selectedMonth.clone().add(-1, 'month'),
                    nextMonth: this.monthes.selectedMonth.clone().add(1, 'month')
                };
            },
            isSelected: function(day){

                if (day.isSame(this.dateStart, 'day') || day.isSame(this.dateEnd, 'day'))
                {
                    return true;
                }

                return false;
            },
            isSelectedB: function(day){
                if (this.compareDates && (day.isSame(this.dateStartB, 'day') || day.isSame(this.dateEndB, 'day')))
                {
                    return true;
                }
            },
            isHighLighted: function(day){

                if (day.isBetween(this.dateStart, this.dateEnd, null, '[]'))
                {
                    return true;
                }

                return false;
            },
            isHighLightedB: function(day){
                if (this.compareDates && (day.isBetween(this.dateStartB, this.dateEndB, null, '[]')))
                {
                    return true;
                }
                return false;
            },
            isDisabled: function(day){

                if (this.endDateIsActive && day.isBefore(this.dateStart, 'day'))
                {
                    return true;
                }

                if (this.startDateIsActive && day.isAfter(this.dateEnd, 'day'))
                {
                    return true;
                }

                return false;
            },
            isStartDate: function(day){
                if (day.isSame(this.dateStart, 'day'))
                {
                    return true;
                }

                return false;
            },
            isStartDateB: function(day){
                if (this.compareDates && (day.isSame(this.dateStartB, 'day')))
                {
                    return true;
                }

                return false;
            },
            isEndDate: function(day){
                if (day.isSame(this.dateEnd, 'day'))
                {
                    return true;
                }

                return false;
            },
            isEndDateB: function(day){
                if (this.compareDates && (day.isSame(this.dateEndB, 'day')))
                {
                    return true;
                }

                return false;
            },
            isExcluded: function(day){

                let dayObjects = this.excludedDates.filter(item => item.isSame(day, 'day'));

                if (dayObjects.length)
                {
                    return true;
                }

                return false;
            },
            isExcludedB: function(day){
                if (this.compareDates && this.excludedDatesB.includes(day))
                {
                    return true;
                }

                return false;
            },
            selectStartDate: function(){
                this.clickableDays =  true;
                this.endDateIsActive = false;
                this.startDateIsActive = true;

                if (this.compareDates){
                    this.startDateBIsActive = false;
                    this.endDateBIsActive = false;
                }
            },
            selectEndDate: function(){
                this.clickableDays = true;
                this.startDateIsActive = false;
                this.endDateIsActive = true;

                if (this.compareDates){
                    this.startDateBIsActive = false;
                    this.endDateBIsActive = false;
                }
            },
            selectStartDateB: function(){
                this.clickableDays =  true;
                this.startDateIsActive = false;
                this.endDateIsActive = false;
                this.endDateBIsActive = false;
                this.startDateBIsActive = true;
            },
            selectEndDateB: function(){
                this.clickableDays = true;
                this.startDateBIsActive = false;
                this.startDateIsActive = false;
                this.endDateIsActive = false;
                this.endDateBIsActive = true;
            },
            clickOnDate: function(day){
                if (this.excludeCustomDate)
                {
                    if (day.isAfter(this.dateStart, 'day') && day.isBefore(this.dateEnd, 'day') ||
                        (day.isAfter(this.dateStartB, 'day') && day.isBefore(this.dateEndB, 'day'))
                    )
                    {
                        let index = this.excludedDates.indexOf(day);

                        if (index !== -1)
                        {
                            this.excludedDates.splice(index, 1);
                        }
                        else
                        {
                            this.excludedDates.push(day);
                        }
                    }
                }
                else if (this.clickableDays)
                {
                    if (!(this.startDateIsActive || this.endDateIsActive || (this.compareDates && (this.startDateBIsActive || this.endDateBIsActive) ) ))
                    {
                        return null;
                    }

                    if (this.endDateIsActive && day.isBefore(this.dateStart, 'day'))
                    {
                        return null;
                    }

                    if (this.startDateIsActive && day.isAfter(this.dateEnd, 'day'))
                    {
                        return null;
                    }

                    if (this.endDateBIsActive && day.isBefore(this.dateStartB, 'day') && this.compareDates)
                    {
                        return null;
                    }

                    if (this.startDateBIsActive && day.isAfter(this.dateEndB, 'day') && this.compareDates)
                    {
                        return null;
                    }

                    this.clickableDay = day;

                    if (this.startDateIsActive && !this.endDateIsActive)
                    {
                        this.dateStart = day;
                        this.selectEndDate();
                    }
                    else if (this.endDateIsActive && !this.startDateIsActive)
                    {
                        this.dateEnd = day;
                        this.selectStartDate();
                    }
                    else if (this.startDateBIsActive && !this.endDateBIsActive && this.compareDates)
                    {
                        this.dateStartB = day;
                        this.selectEndDateB();
                    }
                    else if (this.endDateBIsActive && !this.startDateBIsActive && this.compareDates)
                    {
                        this.dateEndB = day;
                        this.selectStartDateB();
                    }
                }
            },
            applyChanges: function(actionEvent){

                let dateComparisonStatus = false;

                if (this.compareDates === true)
                {
                    dateComparisonStatus = true;
                    actionEvent(this.dateStart, this.dateEnd, this.dateStartB, this.dateEndB, this.excludedDates, this.excludedDatesB);
                }
                else
                {
                    actionEvent(this.dateStart, this.dateEnd, null, null, this.excludedDates, this.excludedDatesB);
                }

                if( this.namespace + '/' in this.$store._modulesNamespaceMap ) {
                    this.$store.dispatch(this.namespace + '/setDateComparisonStatus', dateComparisonStatus);
                }

                this.showDateRange = true;
                this.toggleCalendarForm();
            },
            cancelChanges: function(actionEvent){
                this.toggleCalendarForm();
                // actionEvent(null, null, null, null);
            },
            showMonthesList: function(){
                this.isShowMonthesList = !this.isShowMonthesList;
            },
            useMonth: function(month, year)
            {
                this.currentYear = year;
                this.setMonthes = {
                    selectedMonth: year.month(month),
                    prevMonth: year.month(month).clone().add(-1, 'month'),
                    nextMonth: year.month(month).clone().add(1, 'month')
                };

                this.isShowMonthesList = false;
            },
            selectDateRange: function(period)
            {
                if (period == 'today')
                {
                    this.dateStart = moment().clone();
                    this.dateEnd = moment().clone();
                }
                else if (period == 'yesterday')
                {
                    this.dateStart = moment().add(-1, 'day').clone();
                    this.dateEnd = moment().add(-1, 'day').clone();
                }
                else if (period == 'week')
                {
                    this.dateStart = moment().clone().startOf('week');
                    this.dateEnd = moment().clone().endOf('week');
                }
                else if (period == 'last week')
                {
                    this.dateStart = moment().add(-1, 'week').clone().startOf('week');
                    this.dateEnd = moment().add(-1, 'week').clone().endOf('week');
                }
                else if (period == 'month')
                {
                    this.dateStart = moment().clone().startOf('month');
                    this.dateEnd = moment().clone().endOf('month');
                }
                else if (period == 'last month')
                {
                    this.dateStart = moment().add(-1, 'month').clone().startOf('month');
                    this.dateEnd = moment().add(-1, 'month').clone().endOf('month');
                }
                else if (period == 'days up to date')
                {
                    this.dateStart = moment().add( - this.up_to_today, 'day').clone();
                    this.dateEnd = moment().clone();
                }
                else if (period == 'days up to yesterday')
                {
                    this.dateStart = moment().add( - this.up_to_yesterday, 'day').clone();
                    this.dateEnd = moment().add(-1, 'day').clone();
                }
                else if (period == null)
                {
                    this.dateStart = moment().add(-1, 'day').clone();
                    this.dateEnd = moment().add(-1, 'day').clone();
                }

                this.selectedOption = period;
            },
            selectDateRangeCompare: function(period){
                if (period == 'previous period')
                {
                    this.dateStartB = this.dateStart.clone().add(-1, 'week');
                    this.dateEndB = this.dateEnd.clone().add(-1, 'week');
                }
                else if (period == 'previous year')
                {
                    this.dateStartB = this.dateStart.clone().add(-1, 'year');
                    this.dateEndB = this.dateEnd.clone().add(-1, 'year');
                }
                else if (period == null)
                {
                    this.dateStartB = this.dateStart.clone().add(-2, 'day');
                    this.dateEndB = this.dateEnd.clone().add(-2, 'day');
                }

                this.selectedOptionCompare = period;
            },
            excludeYesterdayAction: function(status)
            {
                this.excludeYesterday = status;
            },
            excludeCustomDateAction: function(status)
            {
                this.excludeCustomDate = status;
            },
            compareDatesAction: function(status)
            {
                this.compareDates = status;
                this.startDateIsActive = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .choose_date_range_wrapper {
        text-align: right;
        color: #212121;
    }

    .choose_date_range {
        display: inline-block;
        padding: 5px 5px 5px 10px;
        background-color: #fff;
        width: auto;
        border: 1px solid #e7e7e7;
        border-radius: 3px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;

        & > div {
            color: #212121;
        }

        & > span {
            cursor: pointer;
        }

        .small {
            font-size: 12px;
            color: #999999;
            text-align: left;
            margin-top: 2px;
            padding-left: 5px;
        }
    }

    .calendar-wrapper {
        position: absolute;
        z-index: 999;
        right: 0px;
        margin-right: 20px;
        background-color: #fff;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas: "options calendar-main"
        "options calendar-main"
        "control-buttons control-buttons";

        //box-shadow: 3px 3px 7px 3px #cbcccd;
        box-shadow: 3px 3px 7px 2px #cbcccd;

        .calendar-options-wrapper {
            grid-area: options;
            text-align: left;
            padding:0;
            padding-top: 5px;
            border: 1px solid #e7e7e7;

            .delimiter {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .date_range_option {
                padding: 10px 15px 10px 15px;
                cursor: pointer;

                & > .date-range-option-input {
                    width: 35px;
                    height: 25px;
                    text-align: center;
                    border: 1px solid #cecece;
                    border-radius: 2px;
                }

                & > .compare-dates-options {
                    & > div {
                        padding-left: 0;
                        font-size: 14px;
                        cursor: pointer;

                        &.activeCompare {
                            color: #4a90e2;
                        }
                    }
                }

                & > .switch-wrapper {
                    cursor: default;
                }

            }

            .date_range_option.active {
                background-color: #4a90e2;
                color: #fff;
            }
        }

        .control-buttons-wrapper {
            grid-area: control-buttons;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 15px;
            border: 1px solid #e7e7e7;

            .control-wrapper {
                display: flex;
                justify-content: flex-end;

                & > div {
                    & > .apply-action {
                        padding: 10px 0;
                        background-color: #4a90e2;
                        border: 1px solid #3474c0;
                        border-radius: 3px;
                        color: #fff;
                    }

                    & > .cancel-action {
                        padding: 10px 0;
                        background-color: #fff;
                        border: 1px solid #dddddd;
                        border-radius: 3px;
                        color: #666666;
                    }
                }

            }
        }

    }

    i.arrow-bottom {
        display: inline-block;
        width: 0.65em;
        height: 0.65em;
        margin-right: 5px;
        margin-left: 5px;
        background-image: url('/static/img/icon-toggle-bottom.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    i.arrow-top{
        display: inline-block;
        width: 0.65em;
        height: 0.65em;
        margin-right: 5px;
        margin-left: 5px;
        background-image: url('/static/img/icon-toggle-top-active.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .arrow-left {
        display: inline-block;
        height: 1em;
        width: 1em;
        background-image: url('/static/img/icon-arrow-left.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .arrow-right {
        display: inline-block;
        height: 1em;
        width: 1em;
        background-image: url('/static/img/icon-arrow-right.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .calendar-main {
        grid-area: calendar-main;
        border: 1px solid #e7e7e7;

        .calendar-header {

            .selectedRange {
                text-align: center;
                margin-top: 15px;
                margin-bottom: 20px;
                color: #212121;

                .date-ranges-delimiter {
                    display: inline-block;
                    background-image: url('/static/img/icon-date-ranges-delimiter.svg');
                    width: 1.75em;
                    height: 0.09em;
                }

                .start_date {
                    float: left;
                    margin-left: 15px;
                    padding: 7px 15px 7px 15px;
                    cursor: pointer;

                    &.active {
                        padding: 7px 15px 7px 15px;
                        background-color: #cadbef;
                        border-radius: 15px;
                    }

                    &.activeB {
                        padding: 7px 15px 7px 15px;
                        background-color: #fdf8bb;
                        border-radius: 15px;
                    }

                }

                .end_date {
                    float: right;
                    margin-right: 15px;
                    padding: 7px 15px 7px 15px;
                    cursor: pointer;

                    &.active {
                        padding: 7px 15px 7px 15px;
                        background-color: #cadbef;
                        border-radius: 15px;
                    }

                    &.activeB {
                        padding: 7px 15px 7px 15px;
                        background-color: #fdf8bb;
                        border-radius: 15px;
                    }

                }

            }

            .weekDays {
                display: grid;
                grid-template-columns: repeat(7, 1fr);
                margin: 10px;
                text-align: center;

                & > span {
                    color: #797979;
                    padding: 5px;
                    text-transform: uppercase;
                }
            }
        }
    }

    .calendar-month-picker {
        display: grid;
        grid-template-columns: 30px auto 30px;
        margin-top: 10px;

        .prevMonth {
            text-align: right;
            cursor: pointer;
        }

        .nextMonth {
            text-align: left;
            cursor: pointer;
        }

        & i.arrow-bottom {
            cursor: pointer;
        }
    }

    .monthes-list-wrapper {
        position: absolute;
        display: block;
        z-index: 5;
        background-color: #fff;
        max-height: 71%;
        width: 49%;
        overflow-y: scroll;

        &::-webkit-scrollbar-track
        {
            border-radius: 8px;
            background-color: #d8d8d8;
        }

        &::-webkit-scrollbar
        {
            width: 8px;
            border-radius: 8px;
            background-color: #9b9b9b;
            height: 12px;
        }

        &::-webkit-scrollbar-thumb
        {
            border-radius: 8px;
            -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,.3);
            background-color: #9b9b9b;
            height: 50%;
        }

        .monthes-list-header {
            text-align: center;
            margin-top: 15px;
            margin-bottom: 15px;
        }

        .monthes-list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);

            & > div {
                padding: 20px;
                text-transform: uppercase;
                cursor: pointer;
            }
        }
    }

    .monthDays, .nextMonthDays {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        margin-left: 15px;
        margin-right: 15px;

        & > div {
            font-size: 14px;
            text-align: center;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;

            & > span {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                color: #797979;
                border-radius: 50%;
                cursor: pointer;
            }
        }

        & > div.day-offset {
            & > span {
                cursor: default;
            }
        }

        & > div.disabled {
            cursor: not-allowed;

            & > span {
                cursor: not-allowed;
                color: red;
                opacity: 0.4;
            }
        }

        & > div.active {
            color: #fff;

            & > span {
                background-color: #4b8bf9;
            }
        }

        & > div.highlighted {
            background-color: #cadbef;
        }

        & > div.highlightedB {
            background-color: #fdf8bb;
        }

        & > div.selected {
            & > span {
                color: #fff;
                background-color: #4b8bf9;
            }
        }

        & > div + .selectedB {
            color: #fff;

            & > span {
                background-color: #efe249;
            }
        }

        & > div + .excludedDay {
            background: #fff;
            border-top: 1px dotted #ccc;
            border-bottom: 1px dotted #ccc;
        }

        & > div.excludedDay:first-child {
            background-color: #cadbef;
            border-right: 1px dotted #ccc;
            border-left: 1px dotted #ccc;
            border-top-right-radius: 50%;
            border-bottom-right-radius: 50%;
        }

        & > div + .highlighted:nth-child(7n){
            border-top-right-radius: 45%;
            border-bottom-right-radius: 45%;
        }

        & > div + .highlighted:last-child{
            border-top-right-radius: 45%;
            border-bottom-right-radius: 45%;
        }

        & > div.startDate {
            background-color: #cadbef;
            border-radius: 0;
            border-top-left-radius: 50%;
            border-bottom-left-radius: 50%;

            & + .highlighted.selected {
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                background-color: #cadbef;
                box-shadow: 1px solid #cecece;
            }

            & > .active {
                border-top-left-radius: 50%;
                border-bottom-left-radius: 50%;
                box-shadow: 1px solid #cecece;
            }

            & > .selected {
                background-color: #4b8bf9;
                color: #fff;
            }
        }

        & > div.endDate {
            background-color: #cadbef;
            border-radius: 0;
            border-top-right-radius: 50%;
            border-bottom-right-radius: 50%;

            & + .highlighted.selected {
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                background-color: #cadbef;
                box-shadow: 1px solid #cecece;
            }

            & > .active {
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                box-shadow: 1px solid #cecece;
                color: #fff;
            }
        }

        & > div.startDateB {
            background-color: #fdf8bb;
            border-radius: 0;
            border-top-left-radius: 50%;
            border-bottom-left-radius: 50%;

            & + .highlightedB.selectedB {
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                background-color: #fdf817;
                box-shadow: 1px solid #cecece;
            }

            & + .selectedB {
                background-color: #efe249;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                box-shadow: 1px solid #cecece;
            }

            & > .active {
                background-color: #efe249;
                border-top-left-radius: 50%;
                border-bottom-left-radius: 50%;
                box-shadow: 1px solid #cecece;
            }
        }

        & > div.endDateB {
            background-color: #fdf8bb;
            border-radius: 0;
            border-top-right-radius: 50%;
            border-bottom-right-radius: 50%;

            & + .selectedB {
                background-color: #efe249;
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                box-shadow: 1px solid #cecece;
            }

            & + .highlightedB.selectedB {
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                background-color: #cadbef;
                box-shadow: 1px solid #cecece;
            }

            & > .active {
                background-color: #efe249;
                border-top-right-radius: 50%;
                border-bottom-right-radius: 50%;
                box-shadow: 1px solid #cecece;
            }
        }

        & > div.startDate.endDate {
            background-color: #fff;
        }

        & > div.startDateB.endDateB {
            border-radius: 50%;
        }
    }

    .nextMonthDays .highlighted:first-child {
        background-color: #cadbef;
        border-top-left-radius: 45%;
        border-bottom-left-radius: 45%;
    }

    .vs-wrapper {
        margin-top: 15px;
        margin-bottom: 15px;
        text-align:center;

        & > span {
            font-size: 12px;
            padding: 6px;
            border: 1px solid #efefef;
            background-color: #efefef;
            border-radius: 50px;
        }
    }

    .arrow-drop-down {
        display: inline-flex;
        align-self: center;
        align-content: center;
        width: 1em;
        height: 1em;
        color: #fff;
        background-image: url('/static/img/icon-arrow-drop-down-blue.svg');
        background-repeat: no-repeat;
        background-position: center;
    }

    @include mobile-only{
        .calendar-wrapper {
            position: absolute;
            top: 0;
            width: 100%;
            display: block;
            margin-right: 0;
            z-index: 10;
            left: 0;
        }

        .choose_date_range {
            border: 0;
        }

        .monthes-list-wrapper{
            width: 100vw;
        }

        .mobile-close-wrapper {
            padding: 20px;
            margin-bottom: 15px;
            background-color: #4a90e2;
            position: sticky;
            z-index: 999;

            & > i.close {
                display: inline-block;
                width: 1em;
                height: 1em;
                margin-left: 5px;
                margin-right: 15px;
                background-image: url('/static/img/icon-close.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }

            & > span {
                color: #fff;
                font-size: 1rem;
            }

            & > span.save {
                float: right;
            }
        }

        .calendar-wrapper .control-buttons-wrapper {
            display: none;
        }

        .choose_date_range_wrapper {
            text-align: center;
        }

        .monthDays, .nextMonthDays {
            & > div.endDate {
                margin-right: 8px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/CCCalendar.vue